export enum SlideDataType {
    MostPopular = 145,
}
